import "core-js/modules/es.array.map.js";
import shortid from 'shortid';
import { get, cloneDeep } from 'lodash';
/**
 * @description 尝试在一个数据上取值 可以有多个备选 keyName
 * @param {Object} parent 被取值的数据
 * @param {Array} paths 可供选择的取值路径
 * @param {*} defaultValue 默认值
 */

export function getFromMulti() {
  var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var paths = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var result = defaultValue;

  for (var pathIndex = 0; pathIndex < paths.length; pathIndex++) {
    var path = paths[pathIndex];
    var value = get(parent, path, defaultValue);

    if (value !== defaultValue) {
      result = value;
      break;
    }
  }

  return result;
}
/**
 * @description 给指定的数组添加唯一 id 字段
 * @description https://github.com/dylang/shortid
 * @param {Array} source 数据源
 * @param {String} idKeyName 字段名
 */

export function arrayAddUniqueId() {
  var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var idKeyName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'id';
  return source.map(function (item) {
    var currentItem = cloneDeep(item);
    currentItem[idKeyName] = shortid.generate();
    return currentItem;
  });
}